module.exports = __webpack_public_path__ + "static/media/parallax1.6f83b9d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/parallax1.jpg
// module id = 94
// module chunks = 0